import { Col, Descriptions, Row } from "antd";
import dayjs from "dayjs";
import { isEmpty, isNull, isUndefined } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { dateFormat } from "../../shared/formatting";

const DocumentSummary = ({ isNew = false }) => {
  const selected = useSelector((state) => state.document.selected);
  const maskSensitiveData =
    useSelector((state) => state.actor?.details?.data?.MaskSensitiveData) &&
    !isNew;

  const isBatched =
    selected &&
    !(isEmpty(selected.AgencyBatchNo) || isNull(selected.AgencyBatchNo));

  const icbcBatch =
    isNull(selected && selected.ICBCBatchNo) ||
    isUndefined(selected && selected.ICBCBatchNo)
      ? "No ICBC Batch"
      : selected.ICBCBatchNo;
  return (
    <Row>
      <Col span={24}>
        {selected && (
          <>
            <Descriptions
              size="small"
              column={3}
              items={[
                {
                  key: "customer",
                  label: "Customer",
                  children: (
                    <div
                      className={
                        maskSensitiveData === true ? "blurry-text" : ""
                      }
                    >
                      {selected.InsuredName}
                    </div>
                  ),
                },
                {
                  key: "product",
                  label: "Product",
                  children: selected.Product,
                },
                {
                  key: "effective",
                  label: "Effective",
                  children: selected.PolicyEffectiveDate
                    ? dayjs(selected.PolicyEffectiveDate).format(dateFormat[0])
                    : "N/A",
                },
                {
                  key: "agency",
                  label: "Agency",
                  children: selected.AgencyNumberAndName,
                },
                {
                  key: "policy",
                  label: "Policy",
                  children: selected.PolicyNumber,
                },
                {
                  key: "expiry",
                  label: "Expiry",
                  children: selected.PolicyExpiryDate
                    ? dayjs(selected.PolicyExpiryDate).format(dateFormat[0])
                    : "N/A",
                },
                {
                  key: "batch",
                  label: "Batch",
                  children: isBatched
                    ? `${selected.AgencyBatchNo}/${icbcBatch} ${dayjs(
                        selected.BatchSubmissionDate
                      ).format(dateFormat[0])}`
                    : "Not batched",
                },
                {
                  key: "documentOrigin",
                  label: "Document Origin",
                  children: selected.IsDownloaded
                    ? "ICBC Download"
                    : "Manual Entry",
                },
                ...(selected.OnlinePortalIndicator
                  ? [
                      {
                        key: "channel",
                        label: "Channel",
                        children: selected.Channel,
                      },
                    ]
                  : []),
              ]}
            />
          </>
        )}
      </Col>
    </Row>
  );
};

export default DocumentSummary;
